import {
    LaboratoryServiceCreateParams,
    LaboratoryServiceUpdateParams,
    LaboratoryServiceListQuery,
    LaboratoryServiceListResponse,
} from 'chaika-frontend-types/frontend-cms';

import { axios } from '@lib/axios';
import { LaboratoryServiceServiceStatus } from 'chaika-enums';

const BASE_URL = '/api/laboratory-service';

export class LaboratoryServiceApi {
    public static async create(laboratoryService: LaboratoryServiceCreateParams): Promise<void> {
        await axios.post(BASE_URL, { laboratoryService });
    }

    public static async update(id: string, laboratoryService: LaboratoryServiceUpdateParams): Promise<void> {
        await axios.put(`${BASE_URL}/${id}`, { laboratoryService });
    }

    public static async updateStatus(id: string, status: LaboratoryServiceServiceStatus): Promise<void> {
        await axios.put(`${BASE_URL}/${id}/status`, { laboratoryService: { status } });
    }

    public static async getList(params?: LaboratoryServiceListQuery): Promise<LaboratoryServiceListResponse> {
        const res = await axios.get<LaboratoryServiceListResponse>(BASE_URL, { params });

        return res.data;
    }
}

export { BASE_URL as LABORATORY_SERVICE_BASE_URL };
